<ng-template #licencesCompanyVisibleFormSearch role="document" let-modal>
  
  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="searchFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="searchFormSubmit()" [formGroup]="searchForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      @if (progressInformationShow) {
        <div class="row">
          <div class="col-12">
            <div class="mb-1">
              <label class="form-label text-right"></label>
              <div class="alert border-0 {{alertColourProgress}}" role="alert">
                <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
              </div>
            </div>
          </div>
        </div>
      }
      
      <div class="row">
        <div class="col-12">
          <div class="border border-success rounded">
            <div class="row">
              <div class="col-12">
                <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center" role="alert">
                  <strong>Available Licences</strong>
                  <app-dropdown-licence-type
                    class="ms-auto flex-shrink-0"
                    [initialLicenceTypeId]="typeLicenceDropDownId"
                    [labelOnTop]="false"
                    (selectOnChangeEvent)="typeLicenceDropDownOnChange($event)"
                  ></app-dropdown-licence-type>
                </div>
              </div>
            </div>
                                        
            <div class="row">
              <div class="col-12">
                <div class="px-2">
                  <app-licences-company-visible-search-embedded #licencesCompanyVisibleSearchGrid
                    [companyId]="companyId"
                    [typeLicenceDropDownDesc]="typeLicenceDropDownDesc"
                    [typeLicenceDropDownId]="typeLicenceDropDownId"
                    (gridRowClick)="gridRowClick($event)"
                    (gridRowDblClick)="gridRowDblClick($event)"
                  ></app-licences-company-visible-search-embedded>
                </div>
              </div>
            </div>
                      
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        @if (!showSystemOwnedToUsers && curUser.isUtelize) {
          <span class="fs-4 me-1">⚠️</span>
          <span class="mb-0">System Owned Licences cannot be seen by a SureSIM user</span>
          <span class="fs-4 ms-1">⚠️</span>
        }
      </div>
      <div class="hstack gap-2">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="searchFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-confirmation-modal-form #addLicenceConfirmationModal
  (modalNo)="noAddLicence()"
  (modalYes)="yesAddLicence()"
></app-confirmation-modal-form>

<app-input-modal-form #inputModalForm
  [input0EnforceGreaterThan0]="true"
  [input0EnforceIntegerInput]="true"
  (thisFormSaved)="inputModalFormSubmitted($event)"
  (thisFormSavedExt)="inputModalFormSubmittedExt($event)"
></app-input-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
